/* eslint-disable no-nested-ternary */
import React, { useContext, useEffect, useState } from 'react';
import {
  AddCircleOutlineRounded, CloseRounded, FmdGoodOutlined, MoreHorizRounded,
} from '@mui/icons-material';
import {
  Box, Container, Divider, Drawer, IconButton, LinearProgress, Stack,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { deleteAddress, getAddress, updateAddress } from '../../../../Redux/Models/address';
import { getUserData } from '../../../../Utils/storages';
import Colors from '../../../../Configs/colors';
import Elements from '../../../Elements';
import ROUTES from '../../../../Configs/routes';
import AlertContext from '../../../../Context/AlertContext';
import Images from '../../../../Configs/images';
// import Colors from '../../../../Configs/colors';

export default function AddressList({
  classes, error, message, data,
}) {
  const navigate = useNavigate();
  const { openAlert } = useContext(AlertContext);
  const { t } = useTranslation();

  useEffect(() => {
    if (error) {
      openAlert({
        severity: 'error',
        message: `Something went wrong, ${message}`,
      });
    }
  }, [error]);

  return (
    <Elements.PageBase navigate={navigate} noNav>
      <Elements.Navigator
        title={t('address.title')}
        secondaryBtn={(
          <IconButton LinkComponent={Link} to="update">
            <AddCircleOutlineRounded fontSize="small" className="black" />
          </IconButton>
        )}
      />
      <div className={classes.root}>

        <div className="mt-2">
          <Container>
            <div className="flex space-between">
              <h4>{t('address.myAdd')}</h4>
              <div className="s-12">
                {data.length}
                {' '}
                {t('address.address')}
              </div>
            </div>

            <AddressBoxes />

          </Container>
        </div>
      </div>
    </Elements.PageBase>
  );
}

export function AddressBoxes({ selectAddress }) {
  const dispatch = useDispatch();
  const userData = getUserData();
  const { address } = useSelector((state) => state);
  const [chosenAddress, setChosenAddress] = useState(null);
  const [readyToDlt, setReadyToDlt] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(getAddress(userData.id));
  }, []);

  useEffect(() => {
    if (address.deletedAddress) {
      setReadyToDlt('');
      setChosenAddress(null);
    }
  }, [address.deletedAddress]);

  const handleDelete = () => {
    dispatch(deleteAddress(userData.id, readyToDlt));
  };

  const setAsMainAddress = async () => {
    await dispatch(updateAddress(
      userData.id,
      chosenAddress.id,
      { ...chosenAddress, is_default: true },
      true,
    ));
    await dispatch(getAddress(userData.id));
    setChosenAddress(null);
  };

  const giveAddress = () => {
    selectAddress(chosenAddress);
    setChosenAddress(null);
  };

  if (address.isLoading) {
    return (
      <LinearProgress color="inherit" sx={{ mt: 2, width: 375 }} />
    );
  }
  if (address.data.length) {
    return (
      <Box position="relative">
        {address.data
          .sort((x, y) => Number(y.is_default) - Number(x.is_default))
          .map((add, index) => (
            <Box mt={1.5} p={1.5} border="1px solid #E5E5E5" borderRadius={1.5} key={index}>
              <Box display="flex" alignItems="center" justifyContent="space-between">
                <div className="weight-700">{add.label}</div>
                {!!add.is_default
              && (
              <Box bgcolor={Colors.primary} py={0.25} px={1} borderRadius={1}>
                <div className="weight-600 white">{t('address.mainAdd')}</div>
              </Box>
              )}
              </Box>
              <Box mt={1}>
                <div className="s-12">{add.name}</div>
                <div className="s-12 mt-1">
                  +
                  {add.phone_number}
                </div>
              </Box>
              <Box mt={0.5} bgcolor="#F5F6F8" borderRadius={1} py={0.5} px={1} display="flex" alignItems="flex-start" gap={1}>
                <FmdGoodOutlined fontSize="small" />
                <div className="s-12">
                  {add.address}
                  ,
                  {' '}
                  {add.city}
                  ,
                  {' '}
                  {add.province}
                  ,
                  {' '}
                  {add.country}
                  ,
                  {' '}
                  {add.postal_code}
                </div>
              </Box>

              <Stack gap={1} mt={1} direction="row">
                <Box
                  flex={1}
                  component={Link}
                  to={`${ROUTES.address()}/update/${add.id}`}
                  border="1px solid #586479"
                  borderRadius={1.5}
                  py={0.75}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  className="black weight-600 link"
                >
                  {t('address.changeAdd')}
                </Box>
                <IconButton
                  sx={{
                    border: '1px solid #586479',
                    borderRadius: 1.5,
                  }}
                  onClick={() => setChosenAddress(add)}
                >
                  <MoreHorizRounded fontSize="small" className="black" />
                </IconButton>

              </Stack>
            </Box>
          ))}

        <Drawer
          anchor="bottom"
          open={!!chosenAddress}
          sx={{
            '& .MuiDrawer-paper': {
              position: 'absolute',
              maxWidth: 375,
              left: window.innerWidth - 375,
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
            },
          }}
          onClose={() => setChosenAddress(null)}
        >
          <Box maxWidth="375px" width="100%" p={2} boxSizing="border-box">
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <h4>{t('address.opt')}</h4>
              <IconButton onClick={() => setChosenAddress(null)}>
                <CloseRounded className="black" />
              </IconButton>
            </Box>
            {!chosenAddress?.is_default && (
            <Box mb={2} className="link" mt={2}>
              <div className="s-16 weight-600" onClick={setAsMainAddress}>{t('address.setMain')}</div>
              <Divider sx={{ mt: 1 }} />
            </Box>
            )}
            {!!selectAddress
            && (
            <Box mb={2} className="link">
              <div className="s-16 weight-600" onClick={giveAddress}>{t('address.choose')}</div>
              <Divider sx={{ mt: 1 }} />
            </Box>
            )}
            {!chosenAddress?.is_default && (
            <Box mb={2} className="link">
              <div className="s-16 weight-600" onClick={() => setReadyToDlt(chosenAddress.id)}>{t('address.deleteAdd')}</div>
              <Divider sx={{ mt: 1 }} />
            </Box>
            )}
          </Box>
        </Drawer>
        <Elements.ConfirmationModal
          open={Boolean(readyToDlt)}
          desc={(
            <div>
              Your action can&apos;t be undone
            </div>
          )}
          title="Delete address?"
          confirmText="Yes delete"
          handleAgree={handleDelete}
          handleClose={() => setReadyToDlt('')}
          isLoading={address.isLoading}
        />
      </Box>
    );
  }
  return (
    <div className="mt-5">
      <div className="center">
        <img src={Images.Address} alt="no address" />

        <div className="s-16 weight-500 mt-4">No available address</div>
        <div className="s-16 mt-3 height-16">
          Add your address by clicking
          <br />
          <strong>Add new address</strong>
          {' '}
          in top
          {' '}
        </div>
      </div>
    </div>
  );
}
